import { Contact } from './contact';

export interface Account {
  category: number;
  contact: Contact;
  deletedOn: string;
  id: number;
  lockedOn: string;
  name: string;
  number: number;
  subnumber: number;
}
